export default "__VITE_ASSET__255032a7__"